export default {
  init,
};

function init(done) {
  done && done();
}
